import { ContactosTecniEntity } from "./contactos_tecni_entity";
import { ContactosClienteEmpresaEntity } from "./contactos_cliente_empresa_entity";

export class DatosPorSegmentoEntity {
    constructor(
        public  UniCod ?:number,
        public  NombreSegmento ?:string,
        public  Direccion ?:string,
        public  Telefono1 ?:string,
        public  Telefono2 ?:string,
        public  ContactosTecni?:ContactosTecniEntity[],
        public  ContactosCliEmpresa?: ContactosClienteEmpresaEntity[]
    ){   }
}
 


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/datos_por_segmento_entity.ts